import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { useWallet } from "../../lib/wallet";
import { toast } from "sonner";
import { Wallet2, FlaskConical } from "lucide-react";

export const WalletModal = ({ open, onClose }) => {
  const w = useWallet();

  const doConnect = () => { onClose(); w.openWallet(); };
  const doDemo = () => { w.connectDemo(); onClose(); toast.success("Demo wallet ready — signatures are produced locally"); };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-s1 border-line text-slate-100 sm:max-w-md" data-testid="wallet-connect-modal">
        <DialogHeader>
          <DialogTitle className="font-heading tracking-tight">{w.connected ? "Wallet" : "Connect a wallet"}</DialogTitle>
          <DialogDescription className="text-slate-400 text-sm">
            Cross is non-custodial. Funds only ever sit in the escrow contract. Every action is a signed message from your wallet.
          </DialogDescription>
        </DialogHeader>

        {w.connected ? (
          <div className="space-y-3">
            <div className="panel p-3 flex items-center justify-between">
              <div>
                <div className="eyebrow">Address</div>
                <div className="mono text-sm mt-1" data-testid="wallet-modal-address">{w.address}</div>
              </div>
              <span className={`tag ${w.kind === "demo" ? "border-warn/40 text-warn" : "border-pos/40 text-pos"}`}>{w.kind === "demo" ? "demo" : "connected"}</span>
            </div>
            <div className="flex gap-2">
              <button className="btn-danger flex-1" onClick={() => { w.disconnect(); onClose(); }} data-testid="wallet-disconnect-btn">Disconnect</button>
              {w.kind === "demo"
                ? <button className="btn-ghost" onClick={w.resetDemo} data-testid="wallet-new-demo-btn">New demo key</button>
                : <button className="btn-ghost" onClick={() => { onClose(); w.openAccount(); }} data-testid="wallet-account-btn">Manage</button>}
            </div>
          </div>
        ) : (
          <div className="space-y-2">
            <button onClick={doConnect} className="w-full panel p-4 text-left hover:border-violet transition-colors flex items-start gap-3" data-testid="wallet-connect-real-btn">
              <Wallet2 size={18} className="text-violet-300 mt-0.5 shrink-0" />
              <div>
                <div className="font-heading font-semibold text-sm">Connect wallet</div>
                <div className="text-xs text-slate-400 mt-1">MetaMask, Rabby &amp; other browser wallets, or scan a QR code with a mobile wallet via WalletConnect.</div>
              </div>
            </button>
            <button onClick={doDemo} className="w-full panel p-4 text-left hover:border-violet transition-colors flex items-start gap-3" data-testid="wallet-demo-btn">
              <FlaskConical size={18} className="text-warn mt-0.5 shrink-0" />
              <div>
                <div className="font-heading font-semibold text-sm flex items-center gap-2">Demo wallet <span className="tag border-warn/40 text-warn">simulated</span></div>
                <div className="text-xs text-slate-400 mt-1">Generates a local key in this browser and signs messages with it. Walk through escrow flows without a real wallet.</div>
              </div>
            </button>
            <p className="text-[11px] text-fog leading-relaxed pt-1" data-testid="wallet-mobile-note">
              On a phone? Tap <span className="text-slate-300">Connect wallet</span> to scan the WalletConnect QR, or open Cross inside your wallet app's built-in browser (e.g. MetaMask or Rabby) to connect directly.
            </p>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
